import { i18n } from '@/plugins/i18n';
import { MessagesError } from '@/globals/messages';

const initOpts = {
  ignore401: false,
  ignore403: false,
  ignore404: false,
};
export default (error, opts = initOpts) => {
  const { ignore401, ignore403, ignore404 } = { ...initOpts, ...opts };
  const status = error?.response?.status || error?.status;
  if (status === 401 && !ignore401) {
    return i18n.t(MessagesError.unauthenticated);
  }
  if (status === 403 && !ignore403) {
    return i18n.t(MessagesError.forbidden);
  }

  if (status === 404 && !ignore404) {
    return i18n.t(MessagesError.resourceNotFound);
  }
  let message =
    error?.response?.data?.message ||
    error?.response?.message ||
    error?.message ||
    '';

  if (MessagesError[message]) {
    message = i18n.t(MessagesError[message]);
  }
  return message || i18n.t(MessagesError.somethingWentWrong);
};
